const Footer = () => {
  return (
    <footer className="w-full py-8 px-6 border-t border-gray-200 bg-header-pattern backdrop-blur-xl">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-500">
          Jonathan Donesky
        </p>
        <div className="flex items-center gap-6">
          <a
            href="https://github.com/jdonesky"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-green-600 transition-colors"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/jdonesky/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-green-600 transition-colors"
          >
            LinkedIn
          </a>
          <a
            href="mailto:jdonesky@gmail.com"
            className="text-sm text-gray-500 hover:text-green-600 transition-colors"
          >
            Email
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
